export enum Status {
	IDLE = 'idle',
	PENDING = 'pending',
	REJECTED = 'rejected',
}
